module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SemiBoldItalic.e7b2ce8.eot";